import { Card } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface UserGrowthChartProps {
  data: { date: string; new_signups: number; churned_users: number }[];
  loading?: boolean;
}

export function UserGrowthChart({ data, loading }: UserGrowthChartProps) {
  return (
    <Card title="User Growth" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="new_signups" name="New Signups" fill="#1677ff" />
          <Bar dataKey="churned_users" name="Churned" fill="#ff4d4f" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
